import React, { useContext } from "react";
import SidePanel from "components/side-panel";
import translations from "locales";
import GlobalContext from "services/global-context";
import * as styles from "./style.mod.scss";
import emptyCartImage from "assets/images/empty-cart.webp";

const EmptyCart = ({ showRecommendations }) => {
  const { cartOpened, toggleCart } = useContext(GlobalContext);

  return (
    <SidePanel
      title={translations.cart.yourEmptyCart}
      open={cartOpened}
      onClose={toggleCart}
      className={`${styles.cart} ${styles.empty} 
    ${!showRecommendations ? `${styles.reducePanelWidth}` : "small-cart"}`}
      bodyClass={styles.body}
      closeIconStyle={styles.closeIcon}
    >
      <span className={styles.subtitle}>
        {translations.cart.emptyCartDescl1}
        {translations.cart.emptyCartDescl2 && (
          <>
            <br />
            {translations.cart.emptyCartDescl2}
          </>
        )}
      </span>
      <img className={styles.emptyImage} src={emptyCartImage} width="200px" height="300px" alt={translations.altText.productImage} />
      <button className={`${styles.checkoutButton} ${styles.checkoutButtonFill}`} onClick={toggleCart}>{translations.cart.continueShopping}</button>
    </SidePanel>
  );
};

export default EmptyCart;